import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
export const useLipStore = create()(immer(set => ({
  files: [],
  uploadedFiles: [],
  errorMessages: [],
  taskName: '',
  isShowDocuploadModal: false,
  isShowDocUploadModalWeb: false,
  trackingItemName: '',
  isDocUploading: false,
  lipDocUploadProps: {
    authToken: '',
    loanNumber: '',
    docUploadUrl: ''
  },
  toastMessageProps: [],
  isShowSeeMoreModal: false,
  showMoreModalData: {
    header: '',
    subHeader: '',
    body: '',
    buttonText: ''
  },
  toastmessageEsign: {
    isShowToastMessage: false,
    message: '',
    buttonText: '',
    type: '',
    trackingItemName: '',
    toastType: 'SUCCESS'
  },
  setShowDocUploadModal: status => set(state => {
    state.isShowDocuploadModal = status;
  }),
  setErrorMessages: errors => set(state => {
    state.errorMessages.push(...errors);
  }),
  clearErrorMessages: errorType => set(state => {
    if (errorType) {
      state.errorMessages = state.errorMessages.filter(e => e.errorType !== errorType);
    } else {
      state.errorMessages = [];
    }
  }),
  setSelectedFiles: filesInfo => set(state => {
    filesInfo.forEach(file => {
      if (state.files && state.files.length < 10) {
        state.files.push(file);
      } else {
        if (state.errorMessages && state.errorMessages.findIndex(err => err.errorType === 'FilesLimit') === -1) {
          state.errorMessages.push({
            errorType: 'FilesLimit'
          });
        }
      }
    });
  }),
  removeFile: index => set(state => {
    if (index >= 0) state.files.splice(index, 1);
  }),
  setTaskName: name => set(state => {
    state.taskName = name;
  }),
  addFile: file => set(state => {
    if (state.files && state.files.length < 10) {
      state.files.push(file);
    } else {
      if (state.errorMessages && state.errorMessages.findIndex(err => err.errorType === 'FilesLimit') === -1) {
        state.errorMessages.push({
          errorType: 'FilesLimit'
        });
      }
    }
  }),
  clearSelectedFiles: () => set(state => {
    state.files = [];
  }),
  setShowDocUploadModalWeb: status => set(state => {
    state.isShowDocUploadModalWeb = status;
  }),
  setTrackingItemName: name => set(state => {
    state.trackingItemName = name;
  }),
  setDocUploading: isLoading => set(state => {
    state.isDocUploading = isLoading;
  }),
  setLipDocUploadProps: lipDocUpload => set(state => {
    state.lipDocUploadProps = lipDocUpload;
  }),
  setToastMessageProps: toastMessageProps => set(state => {
    state.toastMessageProps.push(toastMessageProps);
  }),
  setUploadedFiles: uploadedFiles => set(state => {
    state.uploadedFiles = uploadedFiles;
  }),
  clearUploadedFiles: () => set(state => {
    state.uploadedFiles = [];
  }),
  clearToastMessageProps: () => set(state => {
    state.toastMessageProps = [];
  }),
  setShowSeeMoreModal(status) {
    set(state => {
      state.isShowSeeMoreModal = status;
    });
  },
  setShowMoreModalProps(data) {
    set(state => {
      state.showMoreModalData = data;
    });
  },
  setEsignToastMessage: toastMessageProps => set(state => {
    state.toastmessageEsign = toastMessageProps;
  })
})));
//# sourceMappingURL=index.js.map